// src/components/CharacterCard.js
import React from 'react';
import { avgFromDice } from '../api/dnd';

export default function CharacterCard({
  name, cls, hp, maxHp, weapon, img, side,
  isAttacking=false, isHit=false, auraColor='#60a5fa'
}) {
  const pct = Math.max(0, Math.min(100, (hp / maxHp) * 100));
  const baseDMG = weapon?.base ?? avgFromDice(weapon?.damage) ?? 4; // ✅ number เท่านั้น

  return (
    <div className={['char-card', side==='enemy'?'enemy':'player', isAttacking?'attack-anim':'', isHit?'hit-anim':''].join(' ')}
         style={{ '--aura': auraColor }}>
      <div className="char-header">
        <div className="aura-ring">
          <img src={img} alt={name} className="char-img" draggable={false}/>
        </div>
        <div className="char-info">
          <h3 className="char-name">{name}</h3>
          <p className="cls">{cls}</p>
          {weapon && (
            <p className="weapon">
              🗡️ {weapon.name || 'Bare Hands'}<br/>
              <small>Base {baseDMG} DMG</small> {/* ✅ ไม่แสดง 1d4 */}
            </p>
          )}
        </div>
      </div>

      <div className="hp-bar">
        <div className="hp-fill" style={{ width: `${pct}%` }} />
        <span className="hp-label">HP: {Math.floor(hp)} / {maxHp}</span> {/* ✅ ขาวและอยู่ในหลอด */}
      </div>
    </div>
  );
}
